import React from 'react';
import { Query } from 'react-apollo';
import PropTypes from 'prop-types';

import { BasePage, MobileScreen, TabletScreen } from '@sm/webassets';
import {
  Typography,
  Card,
  Grid,
  Col,
  Row,
  Button,
  Container
} from '@sm/wds-react';

import './solutions.scss';
import modulesQuery from './solutions.graphql';

// Carrousel will be implemented during a next PR
const Carrousel = ({ children }) => <div>{children}</div>;
Carrousel.propTypes = {
  children: PropTypes.node.isRequired
};

const Solutions = () => (
  <BasePage
    color="transparent"
    includeHeader
    includeFooter={false}
    pageId="Market Research - Solutions"
    legacyWeb=""
  >
    <Container
      className="sm-solutions__hero"
      pr={5}
      pl={5}
      flex
      flexDirection="column"
      flexJustify="center"
      flexAlign="center"
    >
      <Typography
        color="light"
        variant="cardTitle"
        className="sm-solutions__hero-name"
      >
        SURVEYMONKEY EXPERT SOLUTIONS
      </Typography>
      <Typography
        color="light"
        variant="hero1"
        component="h1"
        className="sm-solutions__hero-tagline wds-m-t-3"
      >
        <strong>Automate your market research</strong>
      </Typography>
      <Typography
        color="light"
        variant="cardTitle"
        className="sm-solutions__hero-description wds-m-t-3"
      >
        Get polished, presentation-ready insights—in as little as an hour! Our
        solutions help build your survey based on expert methodology, target
        your audience, and analyze your data for you.
      </Typography>
    </Container>
    <Query query={modulesQuery}>
      {({ loading, error, data }) => (
        <Choose>
          <When condition={loading}>Loading</When>
          <When condition={error}>We failed miserably</When>
          <Otherwise>
            <>
              <MobileScreen>
                <Carrousel>
                  {data.modules.items

                    .filter(s => !!s.title && !!s.tagline) // TODO: remove when we have better data
                    .map(solution => (
                      <div key={solution.id}>{solution.title}</div>
                    ))}
                </Carrousel>
              </MobileScreen>
              <TabletScreen>
                <Grid className="sm-solutions__solution-container">
                  <Row>
                    {data.modules.items
                      .filter(s => !!s.title && !!s.tagline) // TODO: remove when we have better data
                      .map(solution => (
                        <Col xs={12} sm={12} md={6} lg={4} key={solution.id}>
                          <Card
                            className="sm-solutions__solution wds-m-b-5"
                            padding={false}
                          >
                            <img
                              src="https://www.petguide.com/wp-content/uploads/2017/09/medium-sized-dog-breeds-whippet.jpg"
                              alt={solution.title}
                              className="sm-solutions__solution-image"
                            />
                            <div className="wds-flex__item--grow">
                              <Typography variant="cardTitle">
                                {solution.title}
                              </Typography>
                              <Typography>{solution.tagline}</Typography>
                            </div>
                            <Container mt={5}>
                              <Typography variant="bodySm" component="span">
                                Starting at&nbsp;
                              </Typography>
                              <Typography
                                component="span"
                                className="sm-solutions__solution-price"
                              >
                                {new Intl.NumberFormat('en-US', {
                                  style: 'currency',
                                  currency: 'USD'
                                }).format(solution.price)}
                              </Typography>
                            </Container>
                            <Grid className="wds-m-t-4" noBleeds>
                              <Row>
                                <Col lg={12} xl={6}>
                                  <Button
                                    stretched
                                    color="upgrade"
                                    className="wds-m-b-3"
                                  >
                                    Get started
                                  </Button>
                                </Col>
                                <Col lg={12} xl={6}>
                                  <Button
                                    variant="ghost"
                                    color="secondary"
                                    stretched
                                    className="wds-m-b-3"
                                  >
                                    Learn more
                                  </Button>
                                </Col>
                              </Row>
                            </Grid>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                </Grid>
              </TabletScreen>
            </>
          </Otherwise>
        </Choose>
      )}
    </Query>
  </BasePage>
);

export default Solutions;
